import { api } from './api';

export default {
  getByFunnelId: async funnelId => {
    try {
      const { data } = await api.get(`/v2/funnel/mediaVisitesRates`, {
        params: { funnelId }
      });
      return data;
    } catch (err) {
      console.error(err);
      return [];
    }
  },
  create: async payload => {
    try {
      const { data } = await api.post(`/v2/funnel/mediaVisitesRates`, payload);
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  update: async (id, payload) => {
    try {
      const { data } = await api.put(
        `/v2/funnel/mediaVisitesRates/${id}`,
        payload
      );
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  },
  delete: async id => {
    try {
      const { data } = await api.delete(`/v2/funnel/mediaVisitesRates/${id}`);
      return data;
    } catch (err) {
      console.error(err);
      return null;
    }
  }
};
